var widget_default = {
  "card": "KowoP",
  "link": "_2TX5-",
  "container": "HtLRA",
  "image": "B2f-U",
  "right": "_1DUIp",
  "cardLayout": "Lkxtt",
  "content": "ALndu",
  "title": "wvhpB",
  "subtitle": "ya7Mt",
  "button": "xksv-",
  "button_disabled": "rqac9",
  "buttonText": "M4ve3",
  "slimLayout": "Pv-3C",
  "contentText": "Q2x-J"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
